module.exports = __webpack_public_path__ + "static/accomodations2.e1dd12b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/accomodations2.jpg
// module id = 448
// module chunks = 13509116309915